import { render, staticRenderFns } from "./breadcrumbs.vue?vue&type=template&id=d79fbe76&vue3"
import script from "./breadcrumbs.vue?vue&type=script&lang=js&vue3"
export * from "./breadcrumbs.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports